import {
  PostAPI,
  PostAPIWithoutRequest,
  PostAPIWithoutRequestAndKeyData,
} from "src/components/api/helper/apiHelper";

export const Insert = async (request: string) => {
  return PostAPI(request, "RegisterSuperStarMaster/Insert");
};

export const Select = async () => {
  return PostAPIWithoutRequest("RegisterSuperStarMaster/Select");
};

export const Delete = async (request: string) => {
  return PostAPI(request, "RegisterSuperStarMaster/Delete");
};

export const Update = async (request: string) => {
  return PostAPI(request, "RegisterSuperStarMaster/Update");
};

export const SelectByID = async (request: string) => {
  return PostAPI(request, "RegisterSuperStarMaster/SelectByID");
};

export const ShowSuperStarDetails = async (request: string) => {
  return PostAPI(request, "RegisterSuperStarMaster/ShowSuperStarDetails");
};

export const SuperStarForDropdown = async () => {
  return PostAPIWithoutRequest("RegisterSuperStarMaster/SuperStarForDropdown");
};